"use client";
import Image from "next/image";
import { useTranslation } from "react-i18next";
import NumbersRightDecorator from "@/assets/images/decorators/numbers-right-decorator.webp";
import { AbsoluteDiv, CustomDiv, InlineDiv } from "@/common/divs";
import { AlmostBoldText, LightText } from "@/common/texts";
import { NEUTRO_TITLES_COLOR } from "@/utils/constants";

const Numbers: React.FC = () => {
  const { t } = useTranslation();
  return (
    <CustomDiv paddingX="108px" paddingY="80px" className="global-padding">
      <InlineDiv
        className="padding-numbers-landing"
        paddingX="64px"
        paddingY="40px"
        style={{
          justifyContent: "space-between",
          background: NEUTRO_TITLES_COLOR,
          borderRadius: "20px",
          flexWrap: "wrap",
          gap: "10px",
        }}
      >
        <CustomDiv>
          <InlineDiv>
            <CustomDiv className="numbers-landing-div" />
            <AlmostBoldText
              style={{ lineHeight: "50px", marginLeft: "10px" }}
              fontSize="54px"
              color="#FFFFFF"
            >
              500+
            </AlmostBoldText>
          </InlineDiv>
          <LightText
            style={{ maxWidth: "135px", marginTop: "10px" }}
            color="#FFFFFF"
          >
            {t("landing.experiences")}
          </LightText>
        </CustomDiv>
        <CustomDiv style={{ zIndex: "9" }}>
          <InlineDiv>
            <CustomDiv className="numbers-landing-div" />
            <AlmostBoldText
              style={{ lineHeight: "50px", marginLeft: "10px" }}
              fontSize="54px"
              color="#FFFFFF"
            >
              100+
            </AlmostBoldText>
          </InlineDiv>
          <LightText
            style={{ maxWidth: "135px", marginTop: "10px" }}
            color="#FFFFFF"
          >
            {t("landing.cities")}
          </LightText>
        </CustomDiv>
        <CustomDiv style={{ zIndex: "9" }}>
          <InlineDiv style={{ minWidth: "135px" }}>
            <CustomDiv className="numbers-landing-div" />
            <AlmostBoldText
              style={{ lineHeight: "50px", marginLeft: "10px" }}
              fontSize="54px"
              color="#FFFFFF"
            >
              10K+
            </AlmostBoldText>
          </InlineDiv>
          <LightText
            style={{ maxWidth: "135px", marginTop: "10px" }}
            color="#FFFFFF"
          >
            {t("landing.additional")}
          </LightText>
        </CustomDiv>
        <CustomDiv style={{ zIndex: "9" }}>
          <InlineDiv style={{ minWidth: "135px" }}>
            <CustomDiv className="numbers-landing-div" />
            <AlmostBoldText
              style={{ lineHeight: "50px", marginLeft: "10px" }}
              fontSize="54px"
              color="#FFFFFF"
            >
              10+
            </AlmostBoldText>
          </InlineDiv>
          <LightText
            style={{ maxWidth: "135px", marginTop: "10px" }}
            color="#FFFFFF"
          >
            {t("landing.categories")}
          </LightText>
        </CustomDiv>
        <AbsoluteDiv right="0px">
          <Image
            style={{
              width: "auto",
              height: "198px",
              marginTop: "-40px",
            }}
            src={NumbersRightDecorator}
            width={0}
            height={0}
            alt="Right Header Decorator"
            priority={true}
          />
        </AbsoluteDiv>
      </InlineDiv>
    </CustomDiv>
  );
};

export default Numbers;
